/*
 * @Author: maxwellllu
 * @Date: 2023-06-06 16:47:22
 * @LastEditors: maxwellllu
 * @LastEditTime: 2023-06-07 11:29:23
 * @FilePath: /privatization-webim/src/components/MockMsg/data/change_lang_msg.js
 * @Description:
 */
export const changeLangGrayMsg = {
  type: 'gray_msg',
  status: 0,
  mine: false,
  crm: {
    crm_flag: 11,
    msg_gray_msg: {
      str_text: '当前服务语言是<a href="javascript:;" class="btn-lang">简体中文</a>',
      uint32_type: 2,
      uint64_from_uin: 938154917,
    },
    msg_webim_extra_data: {
      str_avatar: '',
      str_external_name: '',
      uint64_extuin: 2852199330,
    },
  },
  fromHisotry: false,
  content: {
    gray: '当前语言是：<a href="https://www.baidu.com" class="btn-lang">简体中文</a>',
    track: '',
    msg_webim_extra_data: {
      str_avatar: '',
      str_external_name: '',
      uint64_extuin: 2852199330,
    },
  },
  msgBody: {
    rich_text: '',
  },
};

export const infoForm = {
  type: 'gray_msg',
  status: 0,
  mine: false,
  crm: {
    crm_flag: 11,
    msg_gray_msg: {
      str_text: '客服给您下发了表单<a href="qdweb://webim/launch/pageaction?actionType=consultForm&formId=xxx" rel="noopener noreferrer">填写</a>',
      uint32_type: 2,
      uint64_from_uin: 938154917,
    },
    msg_webim_extra_data: {
      str_avatar: '',
      str_external_name: '',
      uint64_extuin: 2852199330,
    },
  },
  fromHisotry: false,
  content: {
    gray: '客服给您下发了表单<a href="qdweb://webim/launch/pageaction?actionType=consultForm&formId=xxx" rel="noopener noreferrer">填写</a>',
    track: '',
    msg_webim_extra_data: {
      str_avatar: '',
      str_external_name: '',
      uint64_extuin: 2852199330,
    },
  },
  msgBody: {
    rich_text: '',
  },
};
